import { render } from "./Sidebar.vue?vue&type=template&id=4073f6fa&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "../assets/css/inner.css?vue&type=style&index=0&id=4073f6fa&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=4073f6fa&lang=css"

import exportComponent from "C:\\Users\\TATS\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\tsg-exec\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4073f6fa"]])

export default __exports__